var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81168 6.10404L6.81165 6.10402C6.35894 5.90921 5.85153 5.98983 5.46987 6.33238L6.81168 6.10404ZM6.81168 6.10404L26.1754 14.4358L26.5662 13.5277M6.81168 6.10404L26.5662 13.5277M26.5662 13.5277L26.1755 14.4358C26.6753 14.6509 27 15.1302 27 15.7368C27 16.3434 26.6753 16.8228 26.1755 17.0379L26.5707 17.9565M26.5662 13.5277L26.5707 17.9565M26.5707 17.9565L26.1754 17.0379L6.8117 25.3696C6.81169 25.3696 6.81169 25.3696 6.81168 25.3696C6.35948 25.5642 5.852 25.4844 5.46984 25.1413L5.46982 25.1413C5.08301 24.794 4.91194 24.2508 5.04407 23.7135L4.073 23.4747L5.04407 23.7135L6.94692 15.9756L7.00564 15.7368M26.5707 17.9565L7.00564 15.7368M7.00564 15.7368L6.94692 15.498M7.00564 15.7368L6.94692 15.498M6.94692 15.498L5.04407 7.76015L5.04407 7.76014M6.94692 15.498L5.04407 7.76014M5.04407 7.76014C4.91195 7.2229 5.08301 6.67974 5.46981 6.33244L5.04407 7.76014Z",
    stroke: "#666666",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequence);
export default __webpack_public_path__ + "static/media/sequence.095d8f146c67639da9c083df9368b814.svg";
export { ForwardRef as ReactComponent };